export enum PayinFlowMode {
  Requisite = 'requisite',
  PaymentForm = 'payment_form',
}
